export default __webpack_public_path__ + "static/media/PaintingTheLoft_07.2d5612d4.png";